import { environment } from '../../environments/environment';

export const API_HOST = {
  setup: environment.apiHosts.setup,
  facility: environment.apiHosts.facility,
  client: environment.apiHosts.client,
  onboarding: environment.apiHosts.onboarding,
  notification: environment.apiHosts.notification,
  disbursement: environment.apiHosts.disbursement,
  payment_recovery: environment.apiHosts.payment_recovery,
  payment_accrued: environment.apiHosts.payment_accrued,
  leads: environment.apiHosts.leads,
  admin: environment.apiHosts.admin,
  journal: environment.apiHosts.journal,
  brm: environment.apiHosts.brm,
  recovery: environment.apiHosts.recovery,
  reports: environment.apiHosts.reports,
  qpr_reports: environment.apiHosts.qpr_reports,
  tasks: environment.apiHosts.tasks,
  credit_tasks: environment.apiHosts.credit_tasks,
  cradit: environment.apiHosts.cradit,
  monitoring: environment.apiHosts.monitoring,
  repayment: environment.apiHosts.repayment,
  disbursement_note: environment.apiHosts.disbursement_note,
};
